import _ from "lodash";
import { staticAssetsReplacementRegex } from "./staticAssetsPlaceholder.js";
export * from "./staticAssetsPlaceholder.js";
export { compilationThemes } from "./compilation-themes.js";
export { compilationOccasions } from "./compilation-occasions.js";
export { compilationGenres, compilationMoods, compilationSongs, } from "./compilation-songs.js";
// This works like Array.prototype.map, but for objects. It recursively maps all the properties of an object,
// running a callback on each value. The callback can return a new value, or the same value if no change is needed.
// Here, we're using it to replace the static asset placeholder in any strings in the object.
function makeObjectAssetUrlsAbsoluteDeep(obj, { isStaticAsset, getSourceAssetUrl, getCdnUrl, }) {
    if (typeof obj === "string") {
        if (isStaticAsset(obj)) {
            return getSourceAssetUrl(obj);
        }
        else {
            return obj;
        }
    }
    else if (typeof obj !== "object") {
        return obj;
    }
    else if (Array.isArray(obj)) {
        const isStringArray = obj.every((element) => typeof element === "string");
        if (!isStringArray) {
            return obj.map((element) => makeObjectAssetUrlsAbsoluteDeep(element, {
                isStaticAsset,
                getSourceAssetUrl,
                getCdnUrl,
            }));
        }
        // if we're in a string array, assume we can add extra values (a CDN URL)
        const newArray = [];
        for (const element of obj) {
            // if one of the elements is a static asset, we'll want to convert it to a
            // URL and also add a CDN version of the URL before it
            if (typeof element === "string" && isStaticAsset(element)) {
                if (getCdnUrl) {
                    newArray.push(getCdnUrl(element));
                }
                newArray.push(getSourceAssetUrl(element));
            }
            else {
                newArray.push(makeObjectAssetUrlsAbsoluteDeep(element, {
                    isStaticAsset,
                    getSourceAssetUrl,
                    getCdnUrl,
                }));
            }
        }
        return newArray;
    }
    const newObj = {};
    for (const key in obj) {
        newObj[key] = makeObjectAssetUrlsAbsoluteDeep(obj[key], {
            isStaticAsset,
            getSourceAssetUrl,
            getCdnUrl,
        });
    }
    return newObj;
}
function getMakeObjectAssetUrlsAbsoluteDeepCallbacks({ sourceBaseUrl, cdnBaseUrl, }) {
    return {
        isStaticAsset: (val) => staticAssetsReplacementRegex.test(val),
        getSourceAssetUrl: (val) => {
            return val.replace(staticAssetsReplacementRegex, sourceBaseUrl.replace(/\/$/, ""));
        },
        getCdnUrl: cdnBaseUrl
            ? (val) => {
                return val.replace(staticAssetsReplacementRegex, cdnBaseUrl.replace(/\/$/, ""));
            }
            : undefined,
    };
}
function makeObjectAssetUrlsAbsolute(obj, baseUrls) {
    return makeObjectAssetUrlsAbsoluteDeep(obj, getMakeObjectAssetUrlsAbsoluteDeepCallbacks(baseUrls));
}
export function makeCompilationThemeAssetUrlsAbsolute(theme, baseUrls) {
    const newTheme = _.cloneDeep(theme);
    return makeObjectAssetUrlsAbsolute(newTheme, baseUrls);
}
export async function makeCompilationOccasionAssetUrlsAbsolute(occasion) {
    return occasion;
}
export async function makeCompilationSongAssetUrlsAbsolute(song, baseUrls) {
    const newSong = _.cloneDeep(song);
    return makeObjectAssetUrlsAbsolute(newSong, baseUrls);
}
